;(function() {
    const page = document.querySelector('.page')
    const sections = [[7, 15], [15, 21], [21, 24], [0, 7]]
    const classes = ['theme1', 'theme2', 'theme4', 'theme4']

    const getActiveIndex = (h) => {
        let index = 0
        for (let i = 0; i < sections.length; i++) {
            let el = sections[i]
            if (h >= el[0] && h < el[1]) {
                index = i
            }
        }
        return index
    }

    // console.log(...sections)
    // console.log(...classes)
    // for (let h = 0; h < 24; h++) {
    //     let index = getActiveIndex(h)
    //     console.log({h, theme: classes[index]})
    // }

    const setTheme = (index) => {  
        for (let i = 0; i < classes.length; i++) {
            let className = classes[i]
            page.classList.remove(className)
        }
        page.classList.add(classes[index])
    }

    const setThemeByTime = () => {
        let h = new Date().getHours()
        let index = getActiveIndex(h)
        setTheme(index)
    }

    switch (location.hash) {
        case '#test-theme-1':
            setTheme(0)
            break
        case '#test-theme-2':
            setTheme(1)
            break
        case '#test-theme-3':
            setTheme(2)
            break
        case '#test-theme-4':
            setTheme(3)
            break
        default:
            setThemeByTime()
            setInterval(setThemeByTime, 5000)
            console.log('theme run')
            break
    }

})()
